import { h } from 'preact';
import * as BaseComp from 'components/shared/footer/footer.js';
import s from 'components/shared/footer/footer.sss';

export default class Footer extends BaseComp.default {
	getStudioLink() {

		const appData = this.props.appData;
		const footer = appData.footer ? appData.footer : this.props.footerData;
		if (!footer || footer.disableStudioLogo) {
			return;
		}

		let url = 'https://greenwichentertainment.us17.list-manage.com/subscribe/post?u=66fa7b2b379ec4c844d7dcb0f&amp;id=75edcd370e'
		let u = '66fa7b2b379ec4c844d7dcb0f';
		let id = '75edcd370e';

		let result = (
				<div class={s.footerImageContainer}>
					<form class={s.signup} action={url} method="post" name="mc-embedded-subscribe-form" target="_blank" novalidate>
						<label for="mce-EMAIL">SIGN UP FOR UPDATES</label>
						<input type="email" class={s.email} value="" name="EMAIL" id="mce-EMAIL" placeholder="email address" required />
						<input type="text" class={s.hidden} name={'b_'+u+'_'+id} tabindex="-1" value="" aria-hidden="true" />
						<input type="submit" class={s.button} value="Subscribe" name="subscribe" />
					</form>
					<img class={s.studio} alt='footer-studioLogo' src={appData.urls.roots.image + '/' + (footer.studioLogo || 'legal-logos.png')} />
					<img class={s.ratingBug} src={this.props.appData.footer.data.rating} />
				</div>
			);

		if (footer.studioLogoLink) {
			result = (
				<Link
					trackId='studio-logo'
					href={footer.studioLogoLink}
					target='_blank'
				>
					{result}
				</Link>
			);
		}

		return result;
	}
}